<template>
  <footer :class="['footer', { footer_sticky: sticky }]">
    <section class="footer-bottom">
      <div class="footer-bottom__content">
        <div v-if="!isZkm" class="footer-bottom__logo">
          <img src="/assets/favicon.png" alt="CoreEvent" class="white-icon" />
        </div>
        <div v-else class="footer-bottom__logo-zkm">
          <div>Powered by</div>
          <img src="/assets/CoreEvent-logo-black.svg" alt="CoreEvent" class="white-icon" />
        </div>
        <div class="footer-bottom__legal">
          <a
            target="_blank"
            :href="`${landingURL}/en/terms/`"
            :class="['link', isZkm && 'link-zkm']"
          >
            {{ $t('contractForCustomers', 'General conditions of the contract for customers') }}
          </a>
          <a
            target="_blank"
            :href="`${landingURL}/en/personal-data/`"
            :class="['link', isZkm && 'link-zkm']"
          >
            {{ $t('personalDataProtection', 'Protection of personal data') }}
          </a>
        </div>
        <div class="footer-bottom__copyright" :class="isZkm && 'footer-bottom__copyright-zkm'">
          <p>&copy; {{ new Date().getFullYear() }} CoreEvent</p>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import { landingURL } from '@/utils'

export default {
  name: 'application-footer',
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let slug = null

    try {
      if (window.location.href.includes('custom-register')) {
        slug = decodeURIComponent(
          window.location.href.match(new RegExp('(?<=events/).*?(?=/custom-register)'))[0],
        )
      } else if (window.location.href.includes('register')) {
        slug = decodeURIComponent(
          window.location.href.match(new RegExp('(?<=events/).*?(?=/register)'))[0],
        )
      }
    } catch (e) {
      console.error(e)
    }

    return {
      slug,
      landingURL,
    }
  },
  computed: {
    isZkm() {
      return false
    },
  },
}
</script>

<style scoped>
.footer {
  background: white;
  border-radius: 1.75rem 1.75rem 0 0;
}

.footer_sticky {
  height: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.footer-bottom__content {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  gap: 2.625rem;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 1.313rem 2.625rem;
}

.footer-bottom__logo {
  display: flex;
}

.footer-bottom__logo img {
  width: 32px;
}

.footer-bottom__logo-zkm {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-bottom__logo-zkm img {
  height: 32px;
}

.footer-bottom__legal {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.footer-bottom__legal a {
  margin: 0;
  transition: 0.1s ease-in-out;
  display: flex;
  text-decoration-line: underline;
  align-items: center;
}

.footer-bottom__legal a:hover {
  opacity: 0.5;
}

.footer-bottom__copyright {
  text-align: right;
}

.footer-bottom__copyright p {
  color: #0277bd;
  margin-bottom: 0;
}

.footer-bottom__copyright-zkm {
  text-align: right;
}

.footer-bottom__copyright-zkm p {
  color: #333333;
  margin-bottom: 0;
}

@media screen and (max-width: 768px) {
  .footer-bottom__content {
    gap: 1rem;
  }
}

@media (max-width: 576px) {
  .footer-bottom__copyright {
    text-align: center;
  }

  .footer-bottom__content {
    grid-template-columns: 1fr;
    gap: 32px;
    justify-items: center;
    padding-left: 24px;
    padding-right: 24px;
  }
}

.link-zkm {
  color: #333333;
}
</style>
